import { OFFLINE_PATH } from '@/modules/OfflineFiles/OfflineFilesLinks';
import OfflinePhotosUserLIst from '@/modules/OfflineFiles/pages/OfflinePhotosUserLIst';
import SendOfflinePhotosPage from '@/modules/OfflineFiles/pages/SendOfflinePhotosPage';
import { RouteObject } from 'react-router-dom';

export const OFFLINE_FILES_ROUTES: RouteObject[] = [
  {
    path: OFFLINE_PATH.offlinePhotosUsers,
    element: <OfflinePhotosUserLIst />,
  },
  {
    path: OFFLINE_PATH.sendOfflinePhotos,
    element: <SendOfflinePhotosPage />,
  },
];
